import React, { useState, useEffect, useRef } from "react";
import RefundConfirmModal from "./RefundConfirmModal";
import { Calendar, Search, ChevronDown, ChevronUp } from "lucide-react";
import DatePicker from "react-datepicker";
import {
  handleError,
  handleSuccess,
  handleSuccessSession,
  handleSuccessShow,
} from "../../CommonJquery/CommonJquery";
import {
  server_post_data,
  payment_refund_api,
} from "../../ServiceConnection/serviceconnection";
import Loader from "../Loader";

const PaymentRefund = ({
  activeSection,
  refundConfirmModalOpen,
  setRefundConfirmModalOpen,
  driverData,
  master_data_getDriverData,
  master_data_get,
  selectedDriverId,
  selectedDriverBookingId,
  startDateAll,
  endDateAll,
  dateRangeType,
}) => {
  const [startDate, setStartDate] = useState(new Date());
  const [selectedDriver, setSelectedDriver] = useState(null);
  const [isDriverDropdownOpen, setIsDriverDropdownOpen] = useState(false);
  const [driverSearchQuery, setDriverSearchQuery] = useState("");
  const driverDropdownRef = useRef(null);
  const [refundAmonut, setRefundAmount] = useState("");
  const [refundMode, setRefundmode] = useState("");
  const [refundnote, setRefundnote] = useState(0);
  const [FinalRefundAmonut, setFinalRefundAmount] = useState(0);
  const [showLoaderAdmin, setshowLoaderAdmin] = useState(false);
  // Add click outside listener to close dropdown
  useEffect(() => {
    function handleClickOutside(event) {
      if (
        driverDropdownRef.current &&
        !driverDropdownRef.current.contains(event.target)
      ) {
        setIsDriverDropdownOpen(false);
      }
    }

    // Add event listener if dropdown is open
    if (isDriverDropdownOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    // Cleanup the event listener
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isDriverDropdownOpen]);

  const handleSelectDriver = (driver) => {
    setSelectedDriver(driver);
    console.log(driver);
    setIsDriverDropdownOpen(false);
    setDriverSearchQuery("");
    // You can add additional logic here to load transactions for the selected driver
  };
  // Fix: Only search by name and ID (which exists in the driver objects)
  const filteredDrivers = driverData
    ? driverData.filter(
        (driver) =>
          (driver.name ? driver.name.toLowerCase() : "").includes(
            driverSearchQuery.toLowerCase()
          ) ||
          (driver.primary_id
            ? driver.primary_id.toString().toLowerCase()
            : ""
          ).includes(driverSearchQuery.toLowerCase())
      )
    : [];

  const handleSave = async () => {
    if (selectedDriver == null) {
      alert("select Driver");
      return;
    }
    if (parseFloat(refundAmonut) === 0) {
      alert("Charges cannot be zero.");
      return;
    }

    setshowLoaderAdmin(true);
    const fd = new FormData();
    fd.append("booking_id", selectedDriver?.old_booking_data?.primary_id);
    fd.append("car_id", selectedDriver?.old_booking_data?.car_id);
    fd.append("contract_id", selectedDriver?.old_booking_data?.contract_id);
    fd.append("user_id", selectedDriver.primary_id);
    fd.append("amount", refundAmonut);
    fd.append("refundMode", refundMode);
    fd.append("refundnote", refundnote);
    fd.append("refundDate", formatDate(startDate));
    await server_post_data(payment_refund_api, fd)
      .then((Response) => {
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          setRefundAmount("");
          setRefundmode("");
          setRefundnote("");
          setRefundConfirmModalOpen(true);
          // handleSuccessSession(Response.data.message);
          handleSuccessShow("Successfully Saved!");
          master_data_getDriverData();
          master_data_get(
            startDateAll,
            endDateAll,
            2,
            dateRangeType,
            selectedDriverId,
            selectedDriverBookingId
          );
          handleSelectDriver(null);
        }
        setshowLoaderAdmin(false);
      })
      .catch((error) => {
        handleError("network");
        setshowLoaderAdmin(false);
      });
  };

  function formatDate(dateObj) {
    const year = dateObj.getFullYear();
    const month = (dateObj.getMonth() + 1).toString().padStart(2, "0");
    const day = dateObj.getDate().toString().padStart(2, "0");
    return `${year}-${month}-${day}`;
  }

  const handleChargeChange = (e, setter) => {
    const value = e?.target?.value;
    if (value === undefined) return;

    if (parseFloat(value) < 0) {
      alert("Rent cannot be negative");
      return;
    }
    setter(value);
  };

  return (
    <>
      {showLoaderAdmin && <Loader />}
      <section
        id="payment-refund"
        className={`accounting-section ${
          activeSection === "payment-refund" ? "" : "accounting-hidden"
        }`}
      >
        <div className="accounting-refund-container">
          <div className="accounting-refund-header">
            <h2 className="accounting-refund-title">Payment Refund</h2>
            <p className="accounting-refund-subtitle">
              Process refunds back to drivers
            </p>
          </div>

          <div className="accounting-refund-content">
            <div className="accounting-refund-form">
              <div className="accounting-refund-fields">
                <div className="accounting-refund-field">
                  <label htmlFor="refund-date" className="accounting-label">
                    Refund Date
                  </label>
                  <div className="accounting-date-input-wrapper">
                    <DatePicker
                      id="start-date"
                      selected={startDate}
                      onChange={(date) => setStartDate(date)}
                      className="accounting-date-input borderRadiusnew mt-0"
                      placeholderText="MM/DD/YYYY"
                      dateFormat="MM/dd/yyyy"
                      maxDate={new Date()}
                    />
                    <Calendar className="accounting-date-icon" size={18} />
                  </div>
                </div>
                <div className="accounting-refund-field">
                  <label htmlFor="driver-select" className="accounting-label">
                    Select Driver
                  </label>
                  <div className="position-relative" ref={driverDropdownRef}>
                    <div
                      className="form-floating form-control shadow-sm d-flex justify-content-between align-items-center cursor-pointer"
                      onClick={() =>
                        setIsDriverDropdownOpen(!isDriverDropdownOpen)
                      }
                      style={{
                        cursor: "pointer",
                        height: "40px",
                        paddingTop: "10px",
                        marginTop: "6px",
                      }}
                    >
                      {selectedDriver ? (
                        <div className="fw-medium">{selectedDriver.name}</div>
                      ) : (
                        <div className="">Choose a driver</div>
                      )}
                      <div
                        className="position-absolute"
                        style={{
                          bottom: "6px",
                          right: "10px",
                          pointerEvents: "none",
                        }}
                      >
                        {isDriverDropdownOpen ? (
                          <ChevronUp size={16} />
                        ) : (
                          <ChevronDown size={16} />
                        )}
                      </div>
                    </div>

                    {isDriverDropdownOpen && (
                      <div
                        className="position-absolute w-100 bg-white shadow-lg rounded-bottom z-index-1000"
                        style={{ zIndex: 1000 }}
                      >
                        <div className="p-2 border-bottom">
                          <div className="input-group">
                            <span
                              className="input-group-text bg-white border-end-0"
                              style={{ marginTop: "5px" }}
                            >
                              <Search size={16} />
                            </span>
                            <input
                              type="text"
                              className="form-control border-start-0"
                              placeholder="Search by name or ID..."
                              value={driverSearchQuery}
                              onChange={(e) =>
                                setDriverSearchQuery(e.target.value)
                              }
                              autoFocus
                            />
                          </div>
                        </div>
                        <div style={{ maxHeight: "250px", overflowY: "auto" }}>
                          {filteredDrivers.length > 0 ? (
                            filteredDrivers.map((driver) => (
                              <div
                                key={driver.primary_id}
                                className="p-2 border-bottom hover-bg-light cursor-pointer"
                                // onClick={() => handleSelectDriver(driver)}
                                onClick={() => {
                                  const booking = driver?.old_booking_data;

                                  if (!booking) {
                                    alert("This driver has no booking.");
                                    setSelectedDriver(null);
                                    return;
                                  }

                                  const step = booking.step_for_booking;
                                  const switchType =
                                    booking.payment_cycle_switch;

                                  if (
                                    step === "4"
                                  ) {
                                    alert(
                                      "This driver has active booking. We cannot provide refund from an active booking."
                                    );
                                    setSelectedDriver(null);
                                    return;
                                  }
                                  
                                  if (
                                    step === "5" &&
                                    ["1", "2", "3"].includes(switchType)
                                  ) {
                                    alert(
                                      "This driver has no active booking. The last booking was a switched booking."
                                    );
                                    setSelectedDriver(null);
                                    return;
                                  }

                                  if (step === "6") {
                                    alert(
                                      "Please complete the last booking switch process before continuing."
                                    );
                                    setSelectedDriver(null);
                                    return;
                                  }

                                  if (step === "7") {
                                    alert(
                                      "Please complete the last booking repo process before continuing."
                                    );
                                    setSelectedDriver(null);
                                    return;
                                  }

                                  if (["0", "1", "2", "3"].includes(step)) {
                                    alert(
                                      "This driver has a booking in progress but it is not active yet."
                                    );
                                    setSelectedDriver(null);
                                    return;
                                  }

                                  handleSelectDriver(driver);
                                }}
                                style={{ cursor: "pointer" }}
                              >
                                <div className="fw-medium">{driver.name}</div>
                                <div className="small text-muted">
                                  ID: {driver.primary_id}
                                </div>
                              </div>
                            ))
                          ) : (
                            <div className="p-3 text-center text-muted">
                              No drivers found
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>

              <div className="accounting-balance-summary">
                <h3 className="accounting-balance-title">
                  Current Balance Summary
                </h3>
                <div className="accounting-balance-details">
                  <div className="accounting-balance-item">
                    <p className="accounting-balance-label">Outstanding Dues</p>
                    <p className="accounting-balance-value accounting-value-debit">
                      $
                      {(
                        selectedDriver?.old_booking_data?.total_due || 0
                      ).toFixed(2)}
                    </p>
                  </div>
                  <div className="accounting-balance-item">
                    <p className="accounting-balance-label">Credit Balance</p>
                    <p className="accounting-balance-value accounting-value-credit">
                      $
                      {(
                        selectedDriver?.old_booking_data?.paid_deposit || 0
                      ).toFixed(2)}
                    </p>
                  </div>
                </div>
              </div>

              <div className="accounting-refund-amount">
                <label htmlFor="refund-amount" className="accounting-label">
                  Refund Amount ($)
                </label>
                <input
                  type="number"
                  id="refund-amount"
                  placeholder="Enter refund amount"
                  className="accounting-input"
                  value={refundAmonut} // Changed from defaultValue to value for controlled input
                  onChange={(e) => {
                    const newValue = e.target.value;

                    // If input is empty, just update
                    if (newValue === "") {
                      setRefundAmount(newValue);
                      return;
                    }
                    if (newValue < 0) {
                      alert("Rent cannot be negative");
                      return;
                    }
                    const enteredRefund = Number(newValue);

                    // Calculate the maximum refund amount as in your useEffect
                    const totalDue = Number(
                      selectedDriver?.old_booking_data?.paid_deposit || 0
                    );
                    // const totalPaid = Number(selectedDriver?.booking_data?.total_paid || 0);
                    // const totalAmount = Number(selectedDriver?.booking_data?.total_amount || 0);
                    // const totalAdvance = Number(selectedDriver?.booking_data?.total_advance || 0);
                    // const total = totalDue + totalPaid + totalAdvance;
                    // const balance = totalAmount;
                    // const maxRefundAmount = total > balance ? (total - balance) : 0;

                    // Only update state if value is valid
                    if (enteredRefund <= totalDue) {
                      setRefundAmount(newValue);
                      // setFinalRefundAmount(enteredRefund); // Update final amount as well
                    } else {
                      // For invalid values, show alert but don't update state
                      e.preventDefault(); // Prevent default behavior
                      alert(
                        `Entered refund amount cannot be more than the calculated refund amount ($${totalDue})`
                      );
                      // Keep the previous value by not calling setRefundAmount
                    }
                  }}
                />
                <p className="accounting-refund-max">
                  Maximum refund amount: $
                  {selectedDriver?.old_booking_data
                    ? (
                        selectedDriver?.old_booking_data?.paid_deposit || 0
                      ).toFixed(2)
                    : 0}
                </p>
              </div>

              <div className="accounting-refund-method">
                <label htmlFor="refund-method" className="accounting-label">
                  Refund Method
                </label>
                <select
                  id="refund-method"
                  className="accounting-select"
                  // onChange={(e) => handleChargeChange(e , setRefundmode)}>
                  onChange={(e) => setRefundmode(e.target.value)}
                >
                  <option value="">Select a Payment Method</option>
                  <option value="stripe">Stripe</option>
                  <option value="cash">Cash</option>
                  <option value="zelle">Zelle</option>
                  {/* <option>Check</option>
                <option>Wallet Credit</option> */}
                </select>
              </div>

              <div className="accounting-refund-reason">
                <label htmlFor="refund-notes" className="accounting-label">
                  Reason for Refund
                </label>
                <textarea
                  id="refund-notes"
                  rows="3"
                  className="accounting-textarea"
                  placeholder="Provide detailed explanation for the refund"
                  onChange={(e) => setRefundnote(e.target.value)}
                ></textarea>
              </div>

              <div className="accounting-refund-actions">
                <button
                  type="button"
                  className="accounting-btn accounting-btn-primary"
                  onClick={() => handleSave()}
                  // onClick={() => setRefundConfirmModalOpen(true)}
                >
                  Process Refund
                </button>
              </div>
            </div>

            <div className="accounting-refund-sidebar">
              <div className="accounting-info-card accounting-info-card-blue mb-3">
                <h4 className="accounting-info-title">Refund Policy</h4>
                <p className="accounting-info-text">
                  Refunds will be processed within 3-5 business days. Only
                  credit balance can be refunded.
                </p>
              </div>

              <div className="accounting-info-card accounting-info-card-amber mb-3">
                <h4 className="accounting-info-title">Important Note</h4>
                <p className="accounting-info-text">
                  Refunds will appear as debit entries in the driver's ledger
                  and will reduce any available credit balance.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default PaymentRefund;
